import { IButtonStyles } from "@fluentui/react";
import { concatStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { ActionControlSize } from "@1js/acui-common";

import { actionButtonStylingConstants } from "./actionButtonStylingConstants";

export interface SizedButtonStyles {
  small?: IButtonStyles;
  large?: IButtonStyles;
}

/**
 * Creates a styleset
 * @param size The size at which the control is being rendered
 * @param externalStyles External styles for the control, usually coming through props
 * @param sizedStylesForControl The set of styles for particular sizes of a control
 */

type GetSizedButtonStylesFunction = (
  size: ActionControlSize | undefined,
  externalStyles: IButtonStyles | undefined,
  sizedStylesForControl?: SizedButtonStyles
) => IButtonStyles | undefined;

export const getSizedButtonStyles = memoizeFunction<
  GetSizedButtonStylesFunction,
  ReturnType<GetSizedButtonStylesFunction>
>(
  (
    size: ActionControlSize | undefined,
    externalStyles: IButtonStyles | undefined,
    sizedStylesForControl?: SizedButtonStyles
  ) => {
    switch (size) {
      case ActionControlSize.Small:
        return concatStyleSets(
          externalStyles,
          actionButtonStylingConstants.defaultSizedControlStyles.small,
          sizedStylesForControl && sizedStylesForControl.small
        );
      case ActionControlSize.Large:
        return concatStyleSets(
          externalStyles,
          actionButtonStylingConstants.defaultSizedControlStyles.large,
          sizedStylesForControl && sizedStylesForControl.large
        );
    }
    return externalStyles;
  }
);
